import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "notification"];
 
  copy(e) {
    navigator.clipboard.writeText(this.inputTarget.value);
    this.notificationTarget.classList.remove('opacity-0');
    setTimeout(() => {
      this.notificationTarget.classList.add('opacity-0');
    }, 1000);
  }
  
}